import React from 'react';
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import NonSubscriberLoginComponent from '../components/errors/NonSubscriberLoginComponent';
import { getNonSubscriberPageData } from "../store/nonSubscriber/action";
import { getQueryStringValue } from "../utils/utils";
class NonSubscriberLoginContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {}
    this.redirect_url = '';
    this.token = '';

  }
  /**
   * @method componentDidMount
   * to load the data after state changed
   */
  componentDidMount() {
    this.token = getQueryStringValue('token');    
    this.redirect_url = getQueryStringValue('redirect_url');
    this.props.getPageData();

  }
  onHide() {

  }


  render() {
    return (
      <NonSubscriberLoginComponent onHide={this.onHide} pageData={this.props.pageData} token={this.token} redirect_url={this.redirect_url} />
    )
  }

}
//export default HeaderContainer;

/** @mapDispatchToProps
 *  dispatch method to props  
 */

const mapDispatchToProps = {
  getPageData: getNonSubscriberPageData,
};

/** @mapStateToProps
 *  map state to props  
 */

const mapStateToProps = (state) => ({
  pageData: state.nonSubscriber
})

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(NonSubscriberLoginContainer));
